import { Redirect } from 'react-router-dom';
import { ROUTES } from 'routing';
import { useUser } from 'shared/hooks';
import { determineIsAdmin } from 'shared/utility';
import { UserMappingListPage } from './user-mapping-list-page';

export function UserMappingListPageResolver() {
  const user = useUser();

  if (!user) {
    return null;
  }

  const isAdmin = determineIsAdmin(user);

  if (!isAdmin) {
    return <Redirect to={ROUTES.products} />;
  }

  return <UserMappingListPage user={user} />;
}
